import { Text, View } from '@react-pdf/renderer';

import { styles } from '@/components/Contract/Download/style';

const NewJersey = () => {
  return (
    <View style={styles.section}>
      <Text style={styles.title}>New Jersey Specific Terms</Text>

      <View style={styles.list}>
        <Text style={styles.listItem}>
          1. No specific statutes; sellers must warrant premises are habitable.
        </Text>

        <Text style={styles.listItem}>
          2. Attorney Review Clause: Commonly included in contracts.
        </Text>

        <Text style={styles.listItem}>
          3. <Text style={styles.underline}>Lead-Based Paint Disclosure</Text> –
          Only for residences that were built before 1978. This information
          should be available at the County's Revenue Office.
        </Text>
      </View>
    </View>
  );
};

export default NewJersey;
